import { render, staticRenderFns } from "./reportLink.vue?vue&type=template&id=2efd735f"
import script from "./reportLink.vue?vue&type=script&lang=js"
export * from "./reportLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports